import { spinnerTextDefaultStyle, spinnerLightDefaultStyle } from './interstitialContentDefaultStyle';
export const spinnerTextStyleBuilder = (theme, size) => {
  const style = spinnerTextDefaultStyle(theme, size);
  return style;
};
export const spinnerLighStyleBuilder = (theme, size, fullScreen) => {
  const style = spinnerLightDefaultStyle(theme, size, fullScreen);
  return style;
};